import { gql } from '@apollo/client';

export type SEARCH_PEOPLE_ResultType = {
  results: {
    linkedAlready: boolean;
    peopleProfile: {
      id: string;
      firstName: string;
      lastName: string;
    };
  }[];
};

export const SEARCH_PEOPLE = gql`
  query SearchPeople($input: SearchPeopleInput!) {
    results: searchPeople(input: $input) {
      linkedAlready
      peopleProfile {
        id
        firstName
        lastName
        dateOfBirth
        role {
          id
          name
        }
        associatedInstitutions {
          id
          institution {
            id
            name
          }
        }
      }
    }
  }
`;
